import { unleash } from './globals.js';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const APP_CAPABILITIES = ['brandstudio', 'blend'] as const;

export type AppCapability = (typeof APP_CAPABILITIES)[number];

const getAppCapabilities = () => {
  const appCapabilities: AppCapability[] = ['blend'];

  if (unleash?.isEnabled('brandstudio')) {
    appCapabilities.push('brandstudio');
  }

  return appCapabilities;
};

export const getAppCapabilitiesHeader = (): HeadersInit | undefined => {
  const appCapabilities = getAppCapabilities();

  if (appCapabilities.length) {
    return {
      'x-app-capabilities': appCapabilities.join(','),
    };
  }

  return undefined;
};
